import { render } from "./RoomBooking.vue?vue&type=template&id=736e547b&scoped=true"
import script from "@/assets/js/RoomBooking.js?vue&type=script&lang=js"
export * from "@/assets/js/RoomBooking.js?vue&type=script&lang=js"

import "./RoomBooking.vue?vue&type=style&index=0&id=736e547b&scoped=true&lang=css"

import exportComponent from "/tmp/workdir/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736e547b"]])

export default __exports__